import React, { useEffect } from 'react';
import ViewDetails from './component/ViewDetailsPage/ViewDetails';
import { Router, Route, Switch } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import TreemapApplication from './component/TreeMapApplication/TreemapApplication';
import TreeMapEnvironment from './component/TreeMapEnvironment/TreeMapEnvironment';
import MainPage from './component/MainPage';
import { toggleUnmount } from './slices/RiskFilterSlice';

const MainComponent = ({
  history
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      dispatch(toggleUnmount());
    };
  }, []);
  return /*#__PURE__*/React.createElement(Router, {
    history: history
  }, /*#__PURE__*/React.createElement(Switch, null, /*#__PURE__*/React.createElement(Route, {
    exact: true,
    path: "/analytics",
    component: MainPage
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/analytics/details/:appId/:entityUuid/:accountUuid",
    component: ViewDetails
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/analytics/applications/:appId",
    component: TreemapApplication
  }), /*#__PURE__*/React.createElement(Route, {
    path: "/analytics/environments/:appId/:accountUuid",
    component: TreeMapEnvironment
  })));
};

export default MainComponent;